module.exports = __webpack_public_path__ + "img/zephyrus_duo15.1449c9e1.jpg";